<template>
  <v-app>
    <nav v-if="user">
      <v-app-bar app color="primary" dark flat dense clipped-left>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title style="width: 200px">
          <v-img
            alt="Active Indoor"
            class="shrink pa-0"
            contain
            src="./assets/activeindoorlogocolortrans.png"
            transition="scale-transition"
            height="40"
          />
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left>mdi-factory</v-icon>
              Demo
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(factory, index) in factorys" :key="index">
              <v-list-item-title>{{ factory.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list outlined>
            <v-list-item>
              <v-btn text @click="signOut">Sign Out</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer color="primary" dark v-model="drawer" app clipped>
        <v-list>
          <v-list-item
            v-for="item in items"
            :key="item.title"
            router
            :to="item.to"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <template v-slot:append>
          <div>
            <p class="grey--text text--darken-2 text-center caption">
              Powered by Breadcrumb Data
            </p>
          </div>
        </template>
      </v-navigation-drawer>
    </nav>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "./firebase.js";
export default {
  name: "App",
  data: () => ({
    user: null,
    drawer: null,
    items: [
      {
        title: "Real Time Status",
        icon: "mdi-clock-time-eight",
        to: "/realtimestatus",
      },
      // {
      //   title: "Panic",
      //   icon: "mdi-bell-alert-outline",
      //   to: "/panic",
      // },
      // {
      //   title: "In Out Board",
      //   icon: "mdi-swap-horizontal",
      //   to: "/inoutboard",
      // },
      // {
      //   title: "Attendance",
      //   icon: "mdi-account-clock-outline",
      //   to: "/attendance",
      // },
      {
        title: "Contact Tracing",
        icon: "mdi-map-marker-distance",
        to: "/contacttracing",
      },
      {
        title: "Report Outdoor",
        icon: "mdi-crosshairs-gps",
        to: "/reportoutdoorloc",
      },
      // {
      //   title: "Zone Control",
      //   icon: "mdi-hand-left",
      //   to: "/zonecontrol",
      // },
      {
        title: "Bracelet Assignment",
        icon: "mdi-watch-variant",
        to: "/watchassignment",
      },
      {
        title: "Hardware Management",
        icon: "mdi-cube",
        to: "/hardwaremanagement",
      },
      { title: "Feedback", icon: "mdi-comment-quote-outline", to: "/feedback" },
    ],
    right: null,
    factorys: [
      { title: "overview" },
      { title: "factory 1" },
      { title: "factory 2" },
      { title: "factory 3" },
      { title: "factory 4" },
    ],
  }),
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.user = null;
          this.$router.push({ name: "SignIn" });
        });
    },
  },
};
</script>

<style scoped>
</style>>

